import styled from "styled-components";
import { Link } from "react-router-dom";
import colors from "../../styles/colors";

import Primary from "../../components/BtnPrimary";
import BtnNormal from "../../components/Btn";

export const Container = styled.form``;

export const TotalsRow = styled.tr`
  td {
    font-weight: bold;
    padding-top: 5px;
  }
`;

export const LabelColumn = styled.td.attrs(() => ({
  colSpan: 5,
}))`
  text-align: right;
  color: ${colors.text.secondary};
`;

export const DelColumn = styled.td`
  width: 70px;
  text-align: center;
`;

export const BtnPrimary = styled(Primary)`
  margin-left: 40px;
`;

export const Btn = styled(BtnNormal)`
  margin-left: 15px;
`;

export const BtnContinueShopping = styled(Link)`
  display: inline-block;
  background: ${colors.primaryLight};
  border-radius: 12px;
  padding: 10px 16px;
  color: ${colors.text.white};
  border: 0;
  font-size: 15px;
  font-weight: 600;
  box-shadow: 0 2px 8px ${colors.input.focusShadow};
  outline: 0;
  text-decoration: none;
  margin-left: 15px;
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.primaryLightHover};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(126, 185, 205, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const OrderContentWrapper = styled.div<{ $isUpdating?: boolean }>`
  position: relative;
  opacity: ${({ $isUpdating }) => ($isUpdating ? 0.6 : 1)};
  pointer-events: ${({ $isUpdating }) => ($isUpdating ? "none" : "auto")};
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const LoadingText = styled.span`
  color: ${colors.text.secondary};
  font-size: 14px;
`;

export const PaymentSection = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const PaymentMethodSelector = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding: 16px;
  background: ${colors.background.light};
  border-radius: 8px;
`;

export const PaymentMethodLabel = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  font-size: 16px;
`;

export const PaymentMethodRadio = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const PaymentMethodsContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const PaymentMethodCard = styled.div`
  flex: 1;
  min-width: 300px;
`;

export const PaymentMethodTitle = styled.h3`
  margin-bottom: 12px;
  font-size: 18px;
  color: ${colors.text.muted};
`;
